import { useTranslation } from "react-i18next";
import { useState, useEffect } from 'react';



const Languageoption = (props) => {
    const [language, setLanguage] = useState();
    const { t, i18n } = useTranslation()

    useEffect(() => {
        const storedLanguage = localStorage.getItem('language');
        if (storedLanguage) {
            setLanguage(storedLanguage);
            i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);

    const handleLanguageChange = async(event) => {
        const selectedLanguage = event.target.value;
        console.log("eeeeeeeeee",selectedLanguage)
        const bodyData ={
            language:event.target.value == "es" ? "et":event.target.value
          }
        let token = await localStorage.getItem("catzapp_token");
    fetch("https://api.catzapp.com/recruiter/languageupdate/", {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(bodyData),
    })
      .then(res => {
        console.log("checkvaaa",res,"ssss")
        setLanguage(selectedLanguage);
        localStorage.setItem('language', selectedLanguage);
        i18n.changeLanguage(selectedLanguage);
        window.location.reload()
      })
        
    }
    const storedLanguage = localStorage.getItem('language');
    //  const {t} = useTranslation()

    return (
        <div className="btn admin-btn" style={{ color: 'white', border: "none", borderRadius: "none" }} >
            <select className="header-lang" onChange={handleLanguageChange} style={{}} defaultValue={storedLanguage} >
                {/* <option  className="theme-btn-link mt-3" style={{left:"2px"}}>{t('Language')}</option> */}
                <option value={'en'}>{('English')}</option>
                <option value={'fi'}>{('Finnish')}</option>
                <option value={'es'}>{('Estonian')}</option>
                {/* <option value={'es'}>Hindi</option> */}

                {/* <option value={'es'}>Estonian</option> */}
            </select>
        </div>
    )
}
export default Languageoption;




